import { ApiPromise, HttpProvider } from '@polkadot/api';
import { WeightV2 } from '@polkadot/types/interfaces';
import { BN, BN_ONE } from '@polkadot/util';
import { clientEnv } from './env';

let d9Api: ApiPromise;

export const MAX_CALL_WEIGHT = new BN(5_000_000_000_000).isub(BN_ONE);
export const PROOFSIZE = new BN(119903836479112);

export async function getD9Api() {
  if (!d9Api) {
    const httpProvider = new HttpProvider(clientEnv.VITE_D9_NODE_URL);
    d9Api = await ApiPromise.create({ provider: httpProvider, rpc: customRPC });
  }
  await d9Api.isReady;
  return d9Api;
}

export function getGasLimits(d9Api: ApiPromise) {
  return {
    writeLimit: d9Api.registry.createType('WeightV2', {
      refTime: new BN(50_000_000_000),
      proofSize: new BN(800_000),
    }) as WeightV2,
    readLimit: d9Api.registry.createType('WeightV2', {
      refTime: MAX_CALL_WEIGHT,
      proofSize: PROOFSIZE,
    }) as WeightV2,
  };
}

const customRPC = {
  referral: {
    getAncestors: {
      description: 'get ancestors of a referral account',
      params: [
        {
          name: 'account',
          type: 'AccountId',
        },
        {
          name: 'at',
          type: 'Hash',
          isOptional: true,
        },
      ],
      type: 'Vec<AccountId>',
    },
    getParent: {
      description: 'get parent of a referral account',
      params: [
        {
          name: 'account',
          type: 'AccountId',
        },
        {
          name: 'at',
          type: 'Hash',
          isOptional: true,
        },
      ],
      type: 'AccountId',
    },
    getDirectReferralCount: {
      description: 'get direct referrals count of a referral account',
      params: [
        {
          name: 'account',
          type: 'AccountId',
        },
        {
          name: 'at',
          type: 'Hash',
          isOptional: true,
        },
      ],
      type: 'u32',
    },
  },
  voting: {
    getSortedCandidates: {
      description: 'get canidates sorted by votes',
      params: [
        {
          name: 'at',
          type: 'Hash',
          isOptional: true,
        },
      ],
      type: 'Vec<(AccountId, u64)>',
    },
  },
};
